import { useCallback } from 'react';
import { prop } from 'ramda';
import { log } from 'log';
import { useAppSelector } from 'js/store/hooks';

export const useGetLoginMode = () => {
    const usernameEmailSwitcher = useAppSelector(prop('usernameEmailSwitcher'));

    return useCallback((userName: string, customEmailRegexp?: string): 'email' | 'userName' => {
        const defaultEmailRegexp = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i;

        const emailRegexp = customEmailRegexp
            ? (() => {
                try {
                    if (customEmailRegexp.startsWith('/')) {
                        const flags = customEmailRegexp.substring(customEmailRegexp.lastIndexOf('/') + 1);

                        return new RegExp(customEmailRegexp.slice(1, customEmailRegexp.length - flags.length - 1), flags);
                    }

                    return new RegExp(customEmailRegexp);
                } catch (err) {
                    log('error', err);

                    return defaultEmailRegexp;
                }
            })()
            : defaultEmailRegexp;

        return usernameEmailSwitcher && emailRegexp.test(userName) ? 'email' : 'userName';
    }, [usernameEmailSwitcher]);
};
